import type { LoginKind } from "@/features/auth/api/login";

export const signInFormText = {
  user: {
    title: "User sign in",
    description: "Enter your email or phone and password to sign in.",
    submitCredentials: "Sign In",
    submitOtp: "Verify and sign in",
  },
  admin: {
    title: "Super admin sign in",
    description: "Enter super admin credentials. A verification code will be sent to your email.",
    submitCredentials: "Send admin OTP",
    submitOtp: "Verify and sign in",
  },
} as const satisfies Record<LoginKind, {
  title: string;
  description: string;
  submitCredentials: string;
  submitOtp: string;
}>;

const signInAsideFeatures = [
  {
    title: "Project-ready pipeline",
    body: "Manage enquiries, visits, bookings, campaigns, and property teams from one desk.",
  },
  {
    title: "Contact-center clarity",
    body: "Give every agent a clean workspace for calls, follow-ups, and appointment handoffs.",
  },
  {
    title: "Role-aware operations",
    body: "Admins, managers, team leaders, and agents see the right CRM surface after sign-in.",
  },
] as const;
